import React, { Component } from 'react'
import { TABLA_REPORTE_EMBARQUE_SECTOR_4 } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { Container, Row, Col } from 'react-bootstrap'

export class ReporteEmbarqueSector4View extends Component {
  render () {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <MuiTable id={TABLA_REPORTE_EMBARQUE_SECTOR_4} />
          </Col>
        </Row>
      </Container>
    )
  }
}
